import type { RouteConfig } from 'vue-router';
import { Role, LicenseFeature } from '@/modules/shared/types';

const route: RouteConfig = {
    path: '/:customer/templates',
    name: 'dashboard-templates',
    component: () => import(/* webpackChunkName: "dashboard" */ './DashboardTemplatesView.vue'),
    meta: {
        role: Role.USER,
        license: [LicenseFeature.ADVANCED],
        authenticated: true,
        navbar: true,
        footer: true,
        settingsTabs: true,
        // settingsTabsGroup: 'company-admin',
        settingsTabsOrder: 50,
        portfolioTabs: false,
        onboarding: true,
        notifications: true,
    },
};

export { route };
